import "./loader.css";
const Loader = () => {
  return (
    <div className="Loader ">
      <div className="spinner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default Loader;
